import { useState } from 'react';

export function createOpenState() {
    const [state, setOpenState] = useState<boolean>(false);

    const isOpen = (): boolean => state;

    const closeChat = (): void => setOpenState(false);

    const openChat = (): void => setOpenState(true);

    return {
        state,
        isOpen,
        closeChat,
        openChat
    };
}
